<template>
  <div v-if="!item.hidden">
    <template
      v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow"
    >
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <el-tooltip
            effect="dark"
            placement="right"
            :content="generateTitle(onlyOneChild.meta.title)"
          >
            <span class="ellipsis-text">
              <item
                :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
                :title="`${generateTitle(onlyOneChild.meta.title)}`"
              />
            </span>
          </el-tooltip>
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu
      v-else ref="subMenu" :index="resolvePath(item.path)"
      popper-append-to-body
    >
      <template slot="title">
        <el-tooltip
          effect="dark"
          placement="right"
          :content="generateTitle(item.meta.title)"
        >
          <span class="ellipsis-text">
            <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="generateTitle(item.meta.title)" />
          </span>
        </el-tooltip>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path';
import { isExternal } from '@/utils/validate';
import { generateTitle } from '@/utils/i18n';
import Item from './Item';
import AppLink from './Link';
import FixiOSBug from './FixiOSBug';

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {
      // onlyOneChild: null // 不能在此处定义，会造成死循环
    };
  },
  created() {
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    },

    // 路由国际化
    generateTitle
  }
};
</script>

<style lang="scss" scoped>
.ellipsis-text {
  min-width: 0;
  white-space: nowrap !important; /* 不换行 */
  overflow: hidden !important; /* 超出隐藏 */
  text-overflow: ellipsis !important; /* 超出部分显示为省略号 */
}
</style>
